<script>
    import { cartStore, getDBLines, dbLinesAvailable } from "../services/shoppingCart";
    import { getOrderData, formatPrice } from "../services/orders";
    import { userStore } from '../services/session';
    import { getRate } from "../services/rate";
    import { _ } from "../services/i18n";

    let rate;

    const getOrderCart = async () => {
        rate = (await getRate()).data;
    
        let order = {}
        if ($cartStore) {
            order = await getOrderData({ orderId: $cartStore });
            if (order.image) {
                order.images = [order.image];
            }
        }

        const dbLines = await getDBLines();
        if (dbLines) {
            order.dbItemsPrice = 0;
            dbLines.forEach(dbItem => {
                order.dbItemsPrice += dbItem.price.finalPrice;
            })
            if (order.getTotalPrice) {
                order.totalScenePrice = order.getTotalPrice + order.dbItemsPrice;
            }
            else {
                order.totalScenePrice = order.dbItemsPrice;
            }
    
            if (dbLines.length && !order.images) {
                order.images = [];
            }
        }
        else {
            order.totalScenePrice = order.getTotalPrice;
        }

        return order;
    };
</script>

{#if !$cartStore && !dbLinesAvailable()}
    <span class="empty-cart">{$_("nav_shoppingCart_empty")}</span>
{:else}
    {#await getOrderCart()}
        <div class="spinner" />
    {:then order}
        <section class="scenes-section">
            {#each order.images as image, indexScene}
                <article>
                    <img src={image} alt="scene" />
                    <span class="name-art"
                        >{$_("nav_shoppingCart_scene") +
                            " " +
                            (indexScene + 1)}</span
                    >
                    <span class="scene-price">
                        {@html order.formatPrice(
                            order.getScenePrice(indexScene),
                            rate,
                            false
                        )}
                    </span>
                </article>
            {/each}
            {#if order.dbItemsPrice && $userStore.getAcl('dbOrders')}
                <article>
                    <span class="name-art">
                        {$_("nav_shoppingCart_dbElements")}
                    </span>
                    <span class="scene-price">
                        {@html formatPrice(order.dbItemsPrice, rate, false)}
                    </span>
                </article>
            {/if}
        </section>
        <section class="nav-total-price-section">
            <span class="total-price-number">
                {$_("nav_shoppingCart_total")}
                <span class="nav-total-price" style="float: right;">
                    {@html formatPrice(order.totalScenePrice, rate, false)}
                </span>
            </span>
            <a
                class="btn-3d third"
                href="/sim3d.html?cartOnly=true#/compositor/summary"
            >
                {$_("nav_shoppingCart_process")}
            </a>
        </section>
    {/await}
{/if}

<style>
    * {
        text-transform: uppercase;
        letter-spacing: 1.5px;
    }

    .total-price-number {
        color: var(--theme-color-4);
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        font-weight: 500;
        font-size: 22px;
    }
    .empty-cart {
        display: block;
        width: 100%;
        text-align: center;
        color: var(--theme-color-4);
        font-size: 20px;
        text-transform: uppercase;
        letter-spacing: 1.7px;
    }

    article {
        margin: 0 10%;
        margin-bottom: 2rem;
    }

    img {
        width: 100%;
        outline: var(--theme-color-1) solid 2px;
    }

    .name-art {
        display: block;
        color: var(--theme-color-1);
        font-size: 0.9rem;
        margin-top: 5px;
    }

    .scene-price {
        color: var(--theme-color-4);
        font-size: 20px;
    }

    .nav-total-price-section {
        font-size: 18px;
        flex-direction: column;
        color: var(--theme-color-4);
        display: flex;
        justify-content: space-between;
        width: 80%;
        margin: auto auto 30px;
        padding-top: 15px;
    }

    .scenes-section::-webkit-scrollbar {
        width: 8px;
        background-color: var(--gray-color);
    }

    .scenes-section::-webkit-scrollbar-thumb {
        background-color: var(--theme-color-2);
    }

    .scenes-section {
        overflow-y: auto;
        padding: 10px 0;
        scrollbar-width: thin;
        scrollbar-color: var(--theme-color-2) var(--gray-color);
    }

    .spinner {
        width: 30px;
        height: 30px;
        margin: auto;
        border-radius: 20px;
        border: solid 5px var(--theme-color-4);
        border-top: solid 5px white;
        animation: spinner-animation 1s infinite linear;
    }

    @keyframes spinner-animation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
